import React from 'react';

const EmptyState: React.FC<{ onCreateNewProject: () => void }> = ({ onCreateNewProject }) => {
    return (
        <div className="flex flex-col items-center justify-center h-[32rem] rounded-lg p-8 text-center space-y-10">
            {/* Expanded data viz graphic */}
            <svg
                viewBox="0 0 300 180"
                className="w-[22rem] h-[12rem] text-black"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
            >
                {/* Grid background */}
                {[30, 60, 90, 120, 150].map((y) => (
                    <path key={y} d={`M0 ${y} H300`} strokeOpacity="0.07" />
                ))}
                {[50, 100, 150, 200, 250].map((x) => (
                    <path key={x} d={`M${x} 0 V180`} strokeOpacity="0.05" />
                ))}

                {/* First line */}
                <polyline
                    points="0,160 40,90 80,110 120,60 160,80 200,40 240,50 280,30"
                    strokeLinejoin="round"
                    strokeLinecap="round"
                />
                {[{x:0,y:160},{x:40,y:90},{x:80,y:110},{x:120,y:60},{x:160,y:80},{x:200,y:40},{x:240,y:50},{x:280,y:30}].map((pt, i) => (
                    <circle key={i} cx={pt.x} cy={pt.y} r="3" fill="currentColor" />
                ))}

                {/* Second lighter line */}
                <polyline
                    points="0,120 40,100 80,90 120,100 160,70 200,90 240,60 280,70"
                    stroke="currentColor"
                    strokeOpacity="0.5"
                    strokeDasharray="4 2"
                />
            </svg>

            <p className="text-sm text-gray-500 max-w-md">
                No projects yet — but your next great data app starts here.
            </p>
            <button
                onClick={() => onCreateNewProject()}
                className="px-3 py-1.5 text-sm bg-black text-white rounded-md font-medium hover:bg-gray-800 transition-colors"
            >
                Create Your First Project
            </button>
        </div>
    );
};

export default EmptyState;
